import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { getStateByPath } from '../../../../redux/selectors';
import { ADD_STATE, REMOVE_STATE } from '../../../../redux/actions/generics/IndexedActions';
import PropTypes from 'prop-types';
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {eventDateService} from "../../../../jwt/_services/eventx/eventDateService";
import {showLoader} from "../../../../components/loader/loader";


const EventDatesSection = (props) => {
    const path = props.path + "/dates";

    const parentState = useSelector(state => getStateByPath(state, props.path));
    const componentState = useSelector((state) => getStateByPath(state, path));
    const { domainObject, app } = parentState?.data || {};
    const { listDomainObjects } = componentState?.data || [];
    const [dates, setDates] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [originalColors, setOriginalColors] = useState({});

    useEffect(() => {
        if (!listDomainObjects || listDomainObjects.length === 0) return;

        mapDatesSectionOptions();
    }, [listDomainObjects]);

    useEffect(() => {
        if (!app || !domainObject?.id)
            return;

        const dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            item: {
                event: { id: domainObject?.id },
                status: null
            }};

        genericIndexedActions.search(path, eventDateService, 0, 100, dataRequest);
    }, []);


    const mapDatesSectionOptions = () => {
        const _dateSectionsOptions = listDomainObjects.sort((a, b) => new Date(a.date) - new Date(b.date));
        setDates(_dateSectionsOptions);
        setIsLoading(false)
    }

    useEffect(() => {
        props.ADD_STATE(path);
        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    const updateEventColor = (e, eventItem) => {
        const newColor = e.target.value;
        // store original color the first time user changes this item
        setOriginalColors(prev => {
            if (prev[eventItem.id] === undefined) {
                return { ...prev, [eventItem.id]: eventItem.color || '' };
            }
            return prev;
        });

        const updatedItem = { ...eventItem, color: newColor };
        setDates(prevOptions =>
            prevOptions.map(item =>
                item.id === eventItem.id ? updatedItem : item
            )
        );
    };

    const saveEventColor = (eventItem) => {
        const original = originalColors[eventItem.id];
        const current = eventItem.color || '';

        // if no original recorded or no change, do nothing and cleanup
        if (original === undefined || original === current) {
            // remove original if exists
            setOriginalColors(prev => {
                if (prev[eventItem.id] === undefined) return prev;
                const copy = { ...prev };
                delete copy[eventItem.id];
                return copy;
            });
            return;
        }

        const dataRequest = {
            fbDataBase:  {
                id : app?.fbDataBase?.id
            },
            item: {
                id: eventItem.id,
                color: eventItem.color
            }
        };

        genericIndexedActions.update(path, eventDateService, eventItem.id, dataRequest)
            .then(() => {
                setOriginalColors(prev => {
                    const copy = { ...prev };
                    delete copy[eventItem.id];
                    return copy;
                });
            })
            .catch(() => {
                // on error, also cleanup original to avoid blocking future edits
                setOriginalColors(prev => {
                    const copy = { ...prev };
                    delete copy[eventItem.id];
                    return copy;
                });
            });
    }

    const saveEventStatus = (eventItem) => {
        eventItem.status = !eventItem.status;
        const dataRequest = {
            fbDataBase:  {
                id : app?.fbDataBase?.id
            },
            item: {
                id: eventItem.id,
                status: eventItem.status
            }
        };
        genericIndexedActions.update(path, eventDateService, eventItem.id, dataRequest);
    }

    const getContrastColor = (hexColor) => {
        if (!hexColor) return "#000000";

        let hex = hexColor.replace("#", "");
        if (hex.length === 3) {
            hex = hex.split("").map(c => c + c).join("");
        }
        if (hex.length !== 6) return "#000000";

        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        // luminancia relativa (YIQ)
        const yiq = (r * 299 + g * 587 + b * 114) / 1000;
        return yiq >= 128 ? "#000000" : "#ffffff";
    };

    const renderContent = (eventItem) => {
        // show gray background when the date is inactive (status false)
        const backgroundColor = eventItem.status ? (eventItem.color || "#ffffff") : "#f2f2f2";
        const textColor = getContrastColor(backgroundColor);

        return <div
            className="datesection_item"
            key={eventItem.id}
            style={{ backgroundColor }}
        >
            <input
                type="checkbox"
                className="datesection_item-checkbox"
                checked={!!eventItem.status}
                onChange={() => saveEventStatus(eventItem)}
            />
            <div className="datesection_item-label" style={{ color: textColor }}>
                <strong>{eventItem.date}</strong>
                <i className="fas fa-pencil edit-icon" aria-hidden="true" />
            </div>
            <label className="datesection_item-colorSelect" title="Editar color">
                <input
                    type="color"
                    value={eventItem.color}
                    onChange={(e) => updateEventColor(e, eventItem)}
                    onBlur={() => saveEventColor(eventItem)}
                />
            </label>
        </div>
    };


    return (
        <div className="datesection">
            {isLoading && showLoader()}
            {dates.length > 0 && !isLoading && dates.map(renderContent)}
        </div>
    );
};

EventDatesSection.propTypes = {
    path: PropTypes.string,
    dates: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            date: PropTypes.string.isRequired,
            color: PropTypes.string,
            status: PropTypes.string,
        })
    )
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    ADD_STATE,
    REMOVE_STATE,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventDatesSection);